import { DUE_RANK } from '../types/models';
import type { Due } from '../types/models';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export interface DueParts {
  due: Due;
  dueLabel: string;
  dueRank: number;
}

/**
 * Convert a concrete due date (YYYY-MM-DD) into the board's urgency bucket,
 * a human label, and a numeric rank. Empty input clears the due entirely.
 */
export function computeDue(dueDate?: string | null): DueParts {
  if (!dueDate) return { due: '', dueLabel: '', dueRank: DUE_RANK[''] };

  const [y, m, d] = dueDate.split('-').map(Number);
  if (!y || !m || !d) return { due: '', dueLabel: '', dueRank: DUE_RANK[''] };

  const dueMs = startOfDay(new Date(y, m - 1, d));
  const todayMs = startOfDay(new Date());
  const diffDays = Math.round((dueMs - todayMs) / 86_400_000);

  let due: Due;
  let dueLabel: string;
  if (diffDays < 0) {
    due = 'overdue';
    dueLabel = `${-diffDays}d late`;
  } else if (diffDays === 0) {
    due = 'today';
    dueLabel = 'Today';
  } else if (diffDays <= 7) {
    due = 'soon';
    dueLabel = WEEKDAYS[new Date(dueMs).getDay()];
  } else {
    due = 'later';
    const dt = new Date(dueMs);
    dueLabel = `${MONTHS[dt.getMonth()]} ${dt.getDate()}`;
  }

  return { due, dueLabel, dueRank: DUE_RANK[due] };
}
